import { render } from "./sendStatisticsReport.vue?vue&type=template&id=7d93fb87&scoped=true"
import script from "./sendStatisticsReport.vue?vue&type=script&lang=js"
export * from "./sendStatisticsReport.vue?vue&type=script&lang=js"

import "./sendStatisticsReport.vue?vue&type=style&index=0&id=7d93fb87&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d93fb87"]])

export default __exports__